export default __webpack_public_path__ + "static/media/NoPricing.33665434.svg";